import { geoLocationInitialState } from '../../client/initialStates';
import { geoLocationFetchSuccessAction } from './actions';
import { createReducer } from '@reduxjs/toolkit';

export const geoLocationSuccessReducer = createReducer(
  geoLocationInitialState,
  builder =>
    builder.addCase(geoLocationFetchSuccessAction, (state, action) => {
      const { payload: currentAddress } = action;
      return { ...state, ...currentAddress };
    })
);
